import React from 'react';
import { Col } from 'antd';
import HyperLink from 'components/Core/HyperLink';
import { WebsiteImage } from 'components/TitleDescription';
import handleSamePathClick from '../utils/handleSamePathClick';

const MegaMenuItem = ({
  type,
  icon,
  alt,
  title,
  link,
  mobileShow = false,
  children,
  setMobileMenuOpened,
}) => {
  return (
    <Col span={24} style={{ padding: '0' }} className={`${mobileShow ? 'mobile-view-only' : ''}`}>
      <li className="mega-menu-item" onClick={() => handleSamePathClick(link, setMobileMenuOpened)}>
        <HyperLink
          data-position="Header - Menu Item CTA"
          href={link}
          state={{ redirectedFromHeaderMenu: true }}
        >
          {type === 'icon-title-desc' && (
            <WebsiteImage className="mega-menu-item--icon" src={icon} alt={alt} />
          )}
          <div className="mega-menu-item--content">
            <p className="mega-menu-item--title">{title}</p>
            {children && <p className="mega-menu-item--description">{children}</p>}
          </div>
        </HyperLink>
      </li>
    </Col>
  );
};

export default MegaMenuItem;
